// extracted by mini-css-extract-plugin
module.exports = {"desc":"LoadMoreProducts_desc__g2aGU","cont":"LoadMoreProducts_cont__PdzrW","button":"LoadMoreProducts_button__0I_l_","textCont":"LoadMoreProducts_textCont__da_Ux"};